import React from 'react'
import { Alert } from 'reactstrap'
import Icon, { IconType } from '../Icon'
import styles from '@bt-react/styles'
import devicePermissionsWarningStyles from './DevicePermissionsWarning.module.scss'

const DevicePermissionsWarning = ({ deviceType = 'camera' }) => (
  <Alert data-bdd={deviceType + '-blocked-warning'} cssModule={styles} color='warning' className={devicePermissionsWarningStyles['device-blocked']}>
    <div className={`${styles['flex-container']} ${devicePermissionsWarningStyles['message-container']}`}>
      <Icon
        className={devicePermissionsWarningStyles['icon']}
        name={IconType.iconName.danger}
        colour={IconType.colour.task}/>
      <div className={styles['flex-container']}>
        <b>Your {deviceType} is currently blocked by your browser.</b>
        <span>Please ’Allow’ your {deviceType} from the
          <Icon
            name={IconType.iconName.lock}
            className={devicePermissionsWarningStyles['lock-icon']}
          />
          icon in the address bar.
        </span>
      </div>
    </div>
  </Alert>
)

export default DevicePermissionsWarning
